export default __webpack_public_path__ + "static/media/account-round.86a5f85a.svg";